import { ApiClient } from './ApiClient';

type PlacesType = {
  [key in string]: PlaceType;
};

type PlaceType = {
  arrow: number;
  trains: Array<TrainsType>;
};

type TrainsType = {
  station_no: string;
  train_no: number;
  place_id: number;
  course: number;
  station_name_former: string;
  station_name_latter: string;
  station_name_former_en: string;
  station_name_latter_en: string;
  destination_name_ja: string;
  destination_name_en: string;
  x_zoom: number | null;
  y_zoom: number | null;
  x_zoom_low_floor: number;
  y_zoom_low_floor: number;
  x_overview: number | null;
  y_overview: number | null;
  x_overview_low_floor: number | null;
  y_overview_low_floor: number | null;
  low_floor_flg: boolean;
  arriving_estimate: Array<ScheduleType>;
};

type ScheduleType = {
  no: string;
  ja: string;
  en: string;
  time: string | null;
};

export type TransitsApiType = { datas: PlacesType; time: string } | null;

export const TransitsApi = async (): Promise<TransitsApiType> => {
  try {
    const response = await ApiClient.get<TransitsApiType>('location_data');
    const transits = response.data;
    return transits;
  } catch (err) {
    // pass
  }

  return null;
};
